/** What is selected on the board: items (an item in a plain group brings its group), or one frame. */
import type { BoardCtx } from "./context";
import type { BoardPart } from "./types";

/** The selection's members of the board service. */
export function selectionPart(ctx: BoardCtx): BoardPart<"content" | "arrows" | "selected" | "select"> {
  const { graph, view } = ctx.deps;
  return {
    content: ctx.content,
    arrows: ctx.arrows,
    selected: ctx.selected,
    select(ids, add = false) {
      // An item in a plain group is picked with its whole group, as Miro does.
      const widened = ids.flatMap((id) => {
        const group = ctx.nodeOf(id)?.group;
        if (!group || ctx.isFrame(group) || add) return [id];
        return graph.state.graph.nodes.filter((n) => n.group === group).map((n) => n.id);
      });
      if (widened.length === 1 && ctx.isFrame(widened[0]!)) return view.selectGroup(widened[0]!);
      const nodes = widened.filter((id) => !ctx.isFrame(id));
      if (!add) return view.selectNodes(nodes);
      const now = new Set(ctx.selectedNodes());
      for (const id of nodes) now.has(id) ? now.delete(id) : now.add(id);
      view.selectNodes([...now]);
    },
  };
}
